module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deleted":"OK.","error_occurred":"An error has occurred."}}')
  delete Component.options._Ctor
}
